var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Settings",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#032f49",
    fillRule: "evenodd",
    d: "M11.438 3c-.622 0-1.126.504-1.126 1.125l-.135.945a1.125 1.125 0 0 1-1.788.741l-.764-.573a1.125 1.125 0 0 0-1.591 0l-.796.796c-.44.44-.44 1.151 0 1.59l.573.765a1.125 1.125 0 0 1-.74 1.788l-.946.136c-.621 0-1.125.503-1.125 1.124v1.126c0 .62.504 1.124 1.125 1.124l.945.136a1.125 1.125 0 0 1 .741 1.788l-.573.764c-.44.44-.44 1.152 0 1.591l.796.796c.44.44 1.151.44 1.59 0l.765-.573a1.125 1.125 0 0 1 1.788.74l.136.946c0 .621.503 1.125 1.124 1.125h1.126c.62 0 1.124-.504 1.124-1.125l.136-.945a1.125 1.125 0 0 1 1.788-.741l.764.573c.44.44 1.152.44 1.591 0l.796-.796c.439-.44.439-1.151 0-1.59l-.573-.765a1.125 1.125 0 0 1 .74-1.788l.946-.136c.621 0 1.125-.503 1.125-1.124v-1.126c0-.62-.504-1.124-1.125-1.124l-.945-.136a1.125 1.125 0 0 1-.741-1.788l.573-.764c.439-.44.439-1.152 0-1.591l-.796-.796a1.125 1.125 0 0 0-1.59 0l-.765.573a1.125 1.125 0 0 1-1.788-.74l-.136-.946c0-.621-.503-1.125-1.124-1.125h-1.126ZM12 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z",
    clipRule: "evenodd",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a60707b279ed51676452c3da317c356b.svg";
export { ForwardRef as ReactComponent };